// extracted by mini-css-extract-plugin
module.exports = {"accordionListWrapper":"accordionListWrapper","is_open":"is_open"};